import React from 'react';
import { Field, reduxForm } from 'redux-form';
import validator from 'validator';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import i18nInstance from '@moka-bo/i18n';
import ExtAuthField from '../../Fields/ReduxForm/ExtAuthField';
import AuthField from '../../Fields/AuthField';
import styles from './style.form.css';

const isPhoneNumberValid = phoneNumber => {
  return (
    phoneNumber.length >= 10 &&
    phoneNumber.length <= 13 &&
    (phoneNumber.substr(0, 3) === '+62' || phoneNumber.substr(0, 1) === '0')
  );
};

const validate = values => {
  const errors = {};
  const { email, password } = values;
  if (!email) {
    errors.email = i18nInstance._(
      t`The email address or phone number is required`
    );
  } else if (isNaN(email) && !validator.isEmail(email)) {
    errors.email = i18nInstance._(t`Enter a valid email address`);
  } else if (!isNaN(email) && !isPhoneNumberValid(email)) {
    errors.email = i18nInstance._(t`Enter a valid phone number`);
  }
  if (!password) {
    errors.password = i18nInstance._(t`Enter a password`);
  } else if (password.length < 6) {
    errors.password = i18nInstance._(t`Password must be 6 or more characters`);
  }
  return errors;
};

function OpenRedirectForm(props) {
  const { handleSubmit, currentlySending, valid } = props;
  const statusButton = currentlySending ? 'active' : '';

  const btnStyle = {
    background: '#3c5daa',
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className={styles['login-form']}>
        <I18n>
          {({ i18n }) => (
            <Field
              component={ExtAuthField}
              name="email"
              placeholder={i18n._(t`you@example.com`)}
              label={i18n._(t`Email address`)}
              type="text"
            />
          )}
        </I18n>

        <I18n>
          {({ i18n }) => (
            <Field
              component={ExtAuthField}
              name="password"
              placeholder={i18n._(t`Password`)}
              label={i18n._(t`Password`)}
              type="password"
            />
          )}
        </I18n>

        <Link
          className="forgot-password-link pull-right mt-20px mb-20px"
          to="/forgot"
        >
          <Trans>Forgot Your Password?</Trans>
        </Link>

        <div className={styles['submit-btn']}>
          <button
            className={`btn btn-primary btn-block has-spinner ${statusButton}`}
            disabled={!valid}
            style={btnStyle}
          >
            <Trans>Sign In</Trans>
          </button>
        </div>
      </form>
    </div>
  );
}

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  toggleEye = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  render() {
    const {
      handleSubmit,
      currentlySending,
      isMokaOpenApiRedirect,
      valid,
    } = this.props;
    const { showPassword } = this.state;
    const statusButton = currentlySending ? 'active' : '';

    if (isMokaOpenApiRedirect) {
      return (
        <OpenRedirectForm
          handleSubmit={handleSubmit}
          currentlySending={currentlySending}
          valid={valid}
        />
      );
    }

    return (
      <div>
        <form onSubmit={handleSubmit} className={styles['login-form']}>
          <I18n>
            {({ i18n }) => (
              <Field
                component={AuthField}
                name="email"
                type="text"
                placeholder={i18n._(t`Email or phone number`)}
                autoCorrect="off"
                maxLength="255"
                autoCapitalize="off"
                spellCheck="false"
              />
            )}
          </I18n>

          <div className={`${styles['password-container']}`}>
            <I18n>
              {({ i18n }) => (
                <Field
                  component={AuthField}
                  name="password"
                  maxLength="40"
                  type={showPassword ? 'text' : 'password'}
                  placeholder={i18n._(t`Password`)}
                />
              )}
            </I18n>

            <div className={`${styles.eyes}`} onClick={this.toggleEye}>
              {showPassword ? (
                <span className="glyphicon glyphicon-eye-open" />
              ) : (
                <span className="glyphicon glyphicon-eye-close" />
              )}
            </div>
          </div>

          <div className={`row ${styles['margin-link']}`}>
            <Link
              className={`${styles.right} forgot-password-link`}
              to="/forgot"
            >
              <Trans>Forgot password?</Trans>
            </Link>
          </div>
          <div className={styles['submit-btn']}>
            <button
              className={`btn btn-primary btn-block has-spinner ${statusButton}`}
              disabled={!valid}
            >
              <Trans>Sign In</Trans>
            </button>
          </div>
        </form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func,
  changeForm: PropTypes.func,
  currentlySending: PropTypes.bool,
};

const mapFormValidation = {
  form: 'loginForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default connect()(reduxForm(mapFormValidation)(LoginForm));
